export var handleCloseEvent = function (_a) {
  var setIsLivePersonSessionActive = _a.setIsLivePersonSessionActive,
    setIsLivePersonEnabled = _a.setIsLivePersonEnabled,
    setCloseLpChat = _a.setCloseLpChat,
    livePersonEventSource = _a.livePersonEventSource,
    setLivePersonAgentName = _a.setLivePersonAgentName,
    setLivePersonAgentInitial = _a.setLivePersonAgentInitial,
    livePersonAgentNickname = _a.livePersonAgentNickname,
    setStreamingText = _a.setStreamingText,
    setCachedMessages = _a.setCachedMessages,
    syncChatMessage = _a.syncChatMessage,
    setLivePersonConversationId = _a.setLivePersonConversationId;
  setIsLivePersonSessionActive(false);
  // disable the LP feature
  setIsLivePersonEnabled(false);
  setCloseLpChat(false);
  // connection closed
  livePersonEventSource.close();
  // Clear agent name
  setLivePersonAgentName('');
  setLivePersonAgentInitial('');
  setLivePersonConversationId('');
  // display end conversation seperator
  var contentSeparatorMessage = {
    role: 'chatContentSeparator',
    content: "".concat(livePersonAgentNickname, " has disconnected from this chat."),
    key: 'agentDisconnected'
  };
  // Clear any streaming message
  setStreamingText('');
  // showing disconnection message
  setCachedMessages(contentSeparatorMessage);
  setCachedMessages({
    role: 'lpChatDisclosure',
    content: 'You will be transferred back to Penny, our AI travel assistant. Please do not include any personal information in the chat.'
  });
  setCachedMessages({
    role: 'chatContentSeparator',
    content: "You are connected to Penny now.",
    key: 'pennyConnected'
  });
  syncChatMessage();
};